export const ID = '08223041-d06b-47c1-9848-5b0e9a8fad62';

export const NAME = 'Contact Form';
